import api from "APP_ROOT/api";
import * as actionTypes from "MODULES/Lots/actionTypes";
import { push } from "react-router-redux";
import { SUCCESS } from "LIB/submission";
import { LOT } from "MODULES/Lots/constants";
import { ID, UUID } from "APP_ROOT/constants";
import { expireLineItems } from "MODULES/Lots/pagination";
import { modifyFormDataForContact } from "MODULES/parts/components/Detail/PurchaseOrders/Create/Create";
import {
  DO_NOT_SHIP,
  DO_NOT_SHIP_REASONS
} from "MODULES/PurchaseOrders/constants";
import { ACTIVE, CREDIT_HOLD, NO_BIZ } from "MODULES/companies/constants";
import { toastr } from "react-redux-toastr";
import _, { get } from "lodash";

function refreshLotAndLineItems(dispatch, lotId) {
  return api.lots.show(lotId).then(resp => {
    dispatch({ type: actionTypes.SET, lot: resp.data });
    dispatch(expireLineItems());
  });
}

export function setTraceHold(val) {
  return (dispatch, getState) => {
    const lotID = getState().lotDetail.getIn([LOT, ID]);

    return api.lots.setTraceHold(lotID, val).then(resp => {
      dispatch({
        type: actionTypes.SET,
        lot: resp.data
      });

      toastr.success(
        "Success",
        val
          ? "Approved Trace Hold"
          : "Rejected Trace Hold, Notification has been sent to Buyer."
      );

      return SUCCESS;
    });
  };
}

export function addCostAdjustment(data) {
  return (dispatch, getState) => {
    const lot = getState().lotDetail.get(LOT);

    return api.lots.costAdjustments.create(lot.get(ID), data).then(() => {
      refreshLotAndLineItems(dispatch, lot.get(UUID));

      return SUCCESS;
    });
  };
}

export function addLineItem(values, lotId, afterCreate) {
  return (dispatch, getState) => {
    const lot = getState().lotDetail.get(LOT);
    const id = lotId || lot.get(ID);

    if (!values.purchase_for_sale) {
      values.reserve_for_seller_id = null;
    }

    if (values.displayCoBuyerFields) {
      values.add_co_buyer = true;
    }

    if (values.displayThirdBuyerFields) {
      values.add_third_buyer = true;
    }

    return api.lots.lineItems.create(id, values).then(() => {
      if (afterCreate) {
        afterCreate();
      } else {
        refreshLotAndLineItems(dispatch, lot.get(UUID));
      }
      return SUCCESS;
    });
  };
}

export function cancel(reason) {
  return (dispatch, getState) => {
    const lot = getState().lotDetail.get(LOT);

    return api.lots
      .cancel(lot.get(ID), reason)
      .then(() => {
        refreshLotAndLineItems(dispatch, lot.get(UUID));
        return Promise.resolve();
      })
      .catch(error => {
        toastr.error("Error", _.get(error, "errors.base[0]"), error.message);
      });
  };
}

export function create(data) {
  return dispatch => {
    if (data.contact_id === "Add") {
      data.contact_id = null;
    }

    return api.lots.create(data).then(resp => {
      const id = resp.data.uuid;
      dispatch(
        push({
          pathname: `/lots/${id}`
        })
      );
      return SUCCESS;
    });
  };
}

export function searchBuyers(filter) {
  return () =>
    api.users
      .search({ active: true, filter, page: 1, limit: 10 })
      .then(resp => Promise.resolve(resp.data.results));
}

export function searchCompanies(filter) {
  return () =>
    api.companies
      .search({
        filter,
        status: [ACTIVE, NO_BIZ, CREDIT_HOLD].join(","),
        sort: "name",
        reverse: false,
        page: 1,
        limit: 20
      })
      .then(resp => Promise.resolve(resp.data.results));
}

export function searchLots(filter) {
  return () =>
    api.lots
      .search({
        filter
      })
      .then(resp => resp.data.results);
}

export function show(id) {
  return dispatch =>
    api.lots.show(id).then(resp => {
      dispatch({
        type: actionTypes.SET,
        lot: resp.data
      });
    });
}

export function updateLineItem(lineItemId, values) {
  return (dispatch, getState) => {
    const lotId = getState().lotDetail.getIn([LOT, UUID]);

    if (!values.purchase_for_sale && values.reserve_for_seller_id) {
      values.reserve_for_seller_id = null;
    }

    return api.lots.lineItems.update(lineItemId, values).then(() => {
      refreshLotAndLineItems(dispatch, lotId);
      return SUCCESS;
    });
  };
}

export function importLineItems(values) {
  return (dispatch, getState) => {
    const lot = getState().lotDetail.get(LOT);
    const fileName = values.file.name;

    return api.attachments.upload(values.file.name).then(resp => {
      const { key, url } = resp.data;
      const formattedAttachment = {
        name: fileName,
        key
      };

      return api.attachments
        .toS3(url, values.file)
        .then(() =>
          api.lots.lineItems
            .import(lot.get(ID), formattedAttachment)
            .then(() => {
              refreshLotAndLineItems(dispatch, lot.get(UUID));
              toastr.info("Processing", "Importing Lots.");
              return SUCCESS;
            })
        )
        .catch(e => Promise.reject(e));
    });
  };
}

export function update(data) {
  return (dispatch, getState) => {
    const lot = getState().lotDetail.get(LOT);

    modifyFormDataForContact(data);

    if (data.shipping_type && data.shipping_type !== DO_NOT_SHIP) {
      DO_NOT_SHIP_REASONS.forEach(field => {
        data[field] = false;
      });
    }

    return api.lots.update(lot.get(ID), data).then(() => {
      refreshLotAndLineItems(dispatch, lot.get(UUID));
      return SUCCESS;
    });
  };
}

export function sync() {
  return (dispatch, getState) => {
    const lotId = getState().lotDetail.getIn(["lot", "id"]);
    return api.lots
      .sync(lotId)
      .then(() => {
        toastr.success("SUCCESS", "Successfully Synced.");

        return SUCCESS;
      })
      .catch(response => {
        toastr.error("ERROR", get(response, "errors", "Sync Failed"));
      });
  };
}



// WEBPACK FOOTER //
// ./app/modules/Lots/actions.js